import axios from 'axios';
import { HOST } from '../../domain/http'

const token = (t) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=TokenDeTiempo`,
    data: { "tokenType": t, "__nonce": "pzj5n3y2", "passKey": "MB_ag7m2l9tamq8b1k6rd4vx" },
});

const register = async (body) => {
    // REQUEST FOR REGISTER TOKEN
    const { data } = await token("Registros");

    // IF NO ERROR, REGISTER USER
    if (!data.error) return axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${HOST}/ajax.php?accion=registerUser`,
        data: { ...body, __token: data.passKey, terms: "ok" },
    });

    // RESOLVE ERROR
    else new Promise((resolve) => resolve({ response: "Something went wrong", statusCode: 500 }));
}

const auth = async (body) => {
    // REQUEST FOR REGISTER TOKEN
    const { data } = await token("Login");

    // IF NO ERROR, REGISTER USER
    if (!data.error) return axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${HOST}/ajax.php?accion=loginUser`,
        data: { ...body, __token: data.passKey, kitQR: true },
    });

    // RESOLVE ERROR
    else new Promise((resolve) => resolve({ response: "Something went wrong", statusCode: 500 }));
}

const update = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=updateUserFromSubsum`,
    data: body,
});

const contract = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=GuardarContratoKitQR`,
    data: body,
});

const sign = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=SignContractKitQR`,
    data: body,
});

const kycToken = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=getTokenSumsubKitQr`,
    data: body,
});

const kycStatus = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=getKYCStatusKitQr`,
    data: body,
});

const checkEmail = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=GetCollectionKitQR`,
    data: body,
});

const confirmBitpos = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=BitposFormPrebuild`,
    data: body,
});

const getContract = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=ObtenerContrato`,
    data: body,
});

const updatePhone = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=updateUserPhone`,
    data: body,
});

export { register, auth, kycToken, kycStatus, update, contract, sign, checkEmail, confirmBitpos, getContract, updatePhone }